import { ReactNode, SyntheticEvent, useEffect, useState } from 'react'
import { Box, Container, Tab, Tabs } from '@mui/material'

import Catalog from './catalog'
import { StandardPageHeader } from 'src/components/MUIBased/pageHeaders'
import NavBarHeading from 'src/components/MUIBased/NavBarHeading'
import { useParams } from 'react-router'
import { useNavigation } from 'src/hooks'

interface TabPanelProps {
    children?: ReactNode
    index: number
    value: string
    slug: string
}

const TabPanel = (props: TabPanelProps) => {
    const { children, value, index, slug, ...other } = props
    return (
        <Box
            role="tabpanel"
            hidden={value !== slug}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === slug && <>{children}</>}
        </Box>
    )
}

const ComponentLibrary = () => {
    const { navigate } = useNavigation()
    const { componentSlug = '' } = useParams<{
        componentSlug: string
    }>()

    const [activeComponentSlug, setActiveComponentSlug] = useState(
        Catalog[0].slug
    )

    const findComponentBySlug = (slug: string) =>
        Catalog.find(item => item.slug === slug)

    const handleTabChange = (_event: SyntheticEvent, newValue: string) => {
        const component = findComponentBySlug(newValue)
        if (component) {
            navigate(`/mui/library/${component.slug}`)
        }
    }

    useEffect(() => {
        const component = findComponentBySlug(componentSlug)
        if (component) {
            setActiveComponentSlug(component.slug)
        } else {
            setActiveComponentSlug(Catalog[0].slug)
        }
    }, [componentSlug])

    return (
        <>
            <StandardPageHeader showAppointmentBookingButton={false} />
            <NavBarHeading showBackButton={false} href="/mui">
                Component Library
            </NavBarHeading>
            <Container>
                <Box sx={{ flexGrow: 1 }}>
                    <Box
                        sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}
                    >
                        <Tabs
                            value={activeComponentSlug}
                            onChange={handleTabChange}
                        >
                            {Catalog.map(item => (
                                <Tab
                                    key={`${item.slug}-tab`}
                                    label={item.title}
                                    value={item.slug}
                                />
                            ))}
                        </Tabs>
                    </Box>
                    {Catalog.map((item, index) => (
                        <TabPanel
                            key={`${item.slug}-tab-panel`}
                            value={activeComponentSlug}
                            index={index}
                            slug={item.slug}
                        >
                            {item.content}
                        </TabPanel>
                    ))}
                </Box>
            </Container>
        </>
    )
}

export default ComponentLibrary
